module.exports = __webpack_public_path__ + "static/ebook.513c2924.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/ebook.jpg
// module id = 712
// module chunks = 23899280101116